// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  admin/src/pages/MenuItems.jsx  —  Quickry Admin
//  Copy to: C:\quickry\admin\src\pages\MenuItems.jsx
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
import { useState, useEffect, useRef } from "react";
import {
  Plus, Edit2, Trash2, Search, Check, X, Loader2,
  ToggleLeft, ToggleRight, RefreshCw, AlertCircle,
  UtensilsCrossed, Flame, Star, ChevronDown, ChevronUp,
  Tag, Leaf, Drumstick, Zap, Filter, Upload, Download, FileSpreadsheet,
} from "lucide-react";

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  BULK UPLOAD MODAL — Menu Items
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function BulkUploadModal({ restaurantId, restaurantName, onClose, onSuccess, T }) {
  const [file,     setFile]     = useState(null);
  const [uploading,setUploading]= useState(false);
  const [result,   setResult]   = useState(null);
  const [error,    setError]    = useState("");
  const fileRef = useRef(null);

  const downloadTemplate = () => {
    const token = localStorage.getItem("adminToken") || localStorage.getItem("token") || "";
    const BASE  = window.location.hostname !== "localhost"
      ? "https://quickry-ivrv.onrender.com/api"
      : "http://localhost:5000/api";
    const a = document.createElement("a");
    a.href = `${BASE}/menu/bulk/template`;
    a.setAttribute("download", "menu_template.xlsx");
    a.click();
  };

  const handleUpload = async () => {
    if (!file) return setError("Please select a file first.");
    setUploading(true); setError(""); setResult(null);
    try {
      const token   = localStorage.getItem("adminToken") || localStorage.getItem("token") || "";
      const BASE    = window.location.hostname !== "localhost"
        ? "https://quickry-ivrv.onrender.com/api"
        : "http://localhost:5000/api";
      const formData = new FormData();
      formData.append("file", file);
      const res  = await fetch(`${BASE}/menu/bulk/${restaurantId}`, {
        method:  "POST",
        headers: { Authorization: `Bearer ${token}` },
        body:    formData,
      });
      const data = await res.json();
      if (data.success) {
        setResult(data);
        onSuccess();
      } else {
        setError(data.message || "Upload failed");
      }
    } catch (e) {
      setError(e.message || "Upload failed");
    }
    setUploading(false);
  };

  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20 }}>
      <div style={{ background:"#fff",borderRadius:20,width:"100%",maxWidth:480,boxShadow:"0 24px 64px rgba(0,0,0,0.2)",overflow:"hidden" }}>
        {/* Header */}
        <div style={{ background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,padding:"20px 24px",display:"flex",justifyContent:"space-between",alignItems:"center" }}>
          <div>
            <div style={{ fontWeight:800,fontSize:"1rem",color:"#fff",display:"flex",alignItems:"center",gap:8 }}>
              <FileSpreadsheet size={18}/> Bulk Upload — Menu Items
            </div>
            <div style={{ fontSize:"0.75rem",color:"rgba(255,255,255,0.8)",marginTop:4 }}>
              {restaurantName}
            </div>
          </div>
          <button onClick={onClose} style={{ background:"rgba(255,255,255,0.2)",border:"none",borderRadius:8,padding:6,cursor:"pointer",display:"flex" }}>
            <X size={18} color="#fff"/>
          </button>
        </div>

        <div style={{ padding:24 }}>
          {/* Step 1 — Download template */}
          <div style={{ background:T.blueLight,border:`1px solid #bfdbfe`,borderRadius:12,padding:"14px 16px",marginBottom:16 }}>
            <div style={{ fontWeight:700,fontSize:"0.82rem",color:T.blue,marginBottom:6 }}>
              Step 1 — Download Template
            </div>
            <div style={{ fontSize:"0.77rem",color:"#374151",marginBottom:10,lineHeight:1.6 }}>
              Excel template mein columns hain: <strong>name, price, category, isVeg, description, mrp, isBestseller, spicyLevel, image, tags</strong>
            </div>
            <button onClick={downloadTemplate} style={{ display:"flex",alignItems:"center",gap:6,background:T.blue,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:"0.8rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit" }}>
              <Download size={14}/> Download Excel Template
            </button>
          </div>

          {/* Step 2 — Fill & upload */}
          <div style={{ fontWeight:700,fontSize:"0.82rem",color:T.text,marginBottom:10 }}>
            Step 2 — Fill & Upload
          </div>

          {/* File drop zone */}
          <div
            onClick={() => fileRef.current?.click()}
            style={{
              border:`2px dashed ${file ? T.primary : T.border}`,
              borderRadius:12, padding:"28px 20px",
              textAlign:"center", cursor:"pointer",
              background: file ? T.primaryLight : "#fafafa",
              marginBottom:14, transition:"all 0.2s",
            }}
          >
            <Upload size={28} color={file ? T.primary : T.textMuted} style={{ margin:"0 auto 10px" }}/>
            {file ? (
              <div>
                <div style={{ fontWeight:700,color:T.primary,fontSize:"0.85rem" }}>{file.name}</div>
                <div style={{ fontSize:"0.73rem",color:T.textMuted,marginTop:4 }}>
                  {(file.size/1024).toFixed(1)} KB · Click to change
                </div>
              </div>
            ) : (
              <div>
                <div style={{ fontWeight:600,color:T.text,fontSize:"0.85rem" }}>Click to select file</div>
                <div style={{ fontSize:"0.73rem",color:T.textMuted,marginTop:4 }}>.csv, .xlsx, .xls · Max 5MB</div>
              </div>
            )}
            <input
              ref={fileRef} type="file" accept=".csv,.xlsx,.xls"
              style={{ display:"none" }}
              onChange={e => { setFile(e.target.files[0]); setResult(null); setError(""); }}
            />
          </div>

          {/* Error */}
          {error && (
            <div style={{ background:T.redLight,border:"1px solid #fecaca",borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:"0.8rem",color:T.red,fontWeight:600 }}>
              ❌ {error}
            </div>
          )}

          {/* Result */}
          {result && (
            <div style={{ background:T.greenLight,border:`1px solid ${T.greenBorder}`,borderRadius:10,padding:"12px 16px",marginBottom:12 }}>
              <div style={{ fontWeight:700,color:T.green,marginBottom:6,display:"flex",alignItems:"center",gap:6 }}>
                <Check size={15}/> {result.message}
              </div>
              <div style={{ fontSize:"0.77rem",color:"#374151" }}>
                ✅ {result.inserted} items added
                {result.skipped > 0 && <span> · ⚠️ {result.skipped} rows skipped</span>}
              </div>
              {result.errors?.length > 0 && (
                <div style={{ marginTop:8,fontSize:"0.73rem",color:T.red }}>
                  {result.errors.slice(0,5).map((e,i) => <div key={i}>• {e}</div>)}
                  {result.errors.length > 5 && <div>...aur {result.errors.length-5} errors</div>}
                </div>
              )}
            </div>
          )}

          {/* Upload button */}
          <button
            onClick={handleUpload}
            disabled={!file || uploading}
            style={{
              width:"100%", padding:"13px",
              background: (!file||uploading) ? "#e5e7eb" : `linear-gradient(135deg,${T.primaryDark},${T.primary})`,
              color: (!file||uploading) ? "#9ca3af" : "#fff",
              border:"none", borderRadius:12, fontWeight:800, fontSize:"0.9rem",
              cursor: (!file||uploading) ? "not-allowed" : "pointer",
              display:"flex", alignItems:"center", justifyContent:"center", gap:8,
              fontFamily:"inherit",
              boxShadow: (!file||uploading) ? "none" : "0 4px 14px rgba(249,115,22,0.3)",
            }}
          >
            {uploading
              ? <><Loader2 size={16} style={{ animation:"spin 1s linear infinite" }}/> Uploading...</>
              : <><Upload size={16}/> Upload & Add Items</>
            }
          </button>
        </div>
      </div>
    </div>
  );
}

const T = {
  primary:"#f97316", primaryDark:"#ea580c", primaryLight:"#fff7ed", primaryMid:"#fed7aa",
  white:"#ffffff", bg:"#f1f5f9", text:"#0f172a", textSub:"#64748b", textMuted:"#94a3b8",
  border:"#e2e8f0", green:"#16a34a", greenLight:"#dcfce7", greenBorder:"#bbf7d0",
  red:"#ef4444", redLight:"#fef2f2", yellow:"#f59e0b", yellowLight:"#fefce8",
  blue:"#2563eb", blueLight:"#eff6ff",
};

const BASE = typeof window !== "undefined" && window.location.hostname !== "localhost"
  ? "https://quickry-ivrv.onrender.com/api"
  : "http://localhost:5000/api";
const getToken = () => localStorage.getItem("adminToken") || localStorage.getItem("token") || "";
const req = async (method, url, body = null) => {
  try {
    const res = await fetch(`${BASE}${url}`, {
      method,
      headers: { "Content-Type":"application/json", Authorization:`Bearer ${getToken()}` },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    return await res.json();
  } catch(e) { return { success:false, message:e.message }; }
};

// ── Zomato style categories ──────────────────────
const CATEGORIES = [
  "Recommended","Starters","Main Course","Breads",
  "Rice & Biryani","Chinese","Soups","Salads",
  "Desserts","Beverages","Combos & Meals","Kids Menu",
];

const SPICY_LEVELS = [
  { val:0, label:"Not Spicy",    emoji:"🟢" },
  { val:1, label:"Mild",         emoji:"🟡" },
  { val:2, label:"Medium",       emoji:"🟠" },
  { val:3, label:"Hot",          emoji:"🔴" },
  { val:4, label:"Extra Hot",    emoji:"🌶️"  },
];

const EMPTY_ITEM = {
  name:"", description:"", price:"", mrp:"",
  category:"Recommended", isVeg:true,
  isAvailable:true, isBestseller:false, isCustomisable:false,
  spicyLevel:0, image:"", tags:[],
};

// ── Item Form Modal ──────────────────────────────
function ItemModal({ item, restaurantId, restaurantName, onClose, onSave }) {
  const [form,    setForm]    = useState(item || EMPTY_ITEM);
  const [saving,  setSaving]  = useState(false);
  const [tab,     setTab]     = useState("basic"); // basic | details
  const [tagInput,setTagInput]= useState("");

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const addTag = () => {
    const t = tagInput.trim();
    if (t && !form.tags?.includes(t)) {
      set("tags", [...(form.tags||[]), t]);
    }
    setTagInput("");
  };

  const removeTag = (t) => set("tags", form.tags.filter(x => x !== t));

  const discount = form.mrp && form.price
    ? Math.round(((form.mrp - form.price) / form.mrp) * 100)
    : 0;

  const handleSave = async () => {
    if (!form.name)     return alert("Item name required!");
    if (!form.price)    return alert("Price required!");
    if (!form.category) return alert("Category required!");

    setSaving(true);
    const payload = { ...form, restaurant: restaurantId, price: Number(form.price), mrp: Number(form.mrp) || Number(form.price) };

    let res;
    if (form._id) res = await req("PUT",  `/menu/${form._id}`, payload);
    else          res = await req("POST", `/menu`, payload);

    setSaving(false);
    if (res.success) onSave(res.data, !!form._id);
    else alert(res.message || "Error saving item!");
  };

  const TAB_BTN = (id, label) => (
    <button onClick={() => setTab(id)}
      style={{ flex:1, background:tab===id?T.primary:"none", color:tab===id?"#fff":T.textSub, border:"none", borderRadius:9, padding:"8px", fontWeight:700, fontSize:"0.8rem", cursor:"pointer", fontFamily:"inherit", transition:"all .2s" }}>
      {label}
    </button>
  );

  return (
    <div onClick={onClose} style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",padding:16 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:T.white,borderRadius:24,width:"100%",maxWidth:520,maxHeight:"92vh",overflowY:"auto",boxShadow:"0 24px 64px rgba(0,0,0,0.2)" }}>

        {/* Header */}
        <div style={{ padding:"18px 20px",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,background:T.white,zIndex:10,borderRadius:"24px 24px 0 0" }}>
          <div>
            <div style={{ fontFamily:"'Fraunces',Georgia,serif",fontWeight:900,fontSize:"1rem",color:T.text }}>
              {form._id ? "Edit Menu Item" : "Add Menu Item"}
            </div>
            <div style={{ fontSize:"0.7rem",color:T.textMuted,marginTop:2 }}>{restaurantName}</div>
          </div>
          <button onClick={onClose} style={{ background:T.bg,border:"none",borderRadius:"50%",width:34,height:34,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer" }}>
            <X size={16} color={T.textSub}/>
          </button>
        </div>

        {/* Tabs */}
        <div style={{ display:"flex",gap:6,padding:"14px 20px 0",background:T.bg }}>
          {TAB_BTN("basic",   "Basic Info")}
          {TAB_BTN("details", "Details & Tags")}
        </div>

        <div style={{ padding:"18px 20px",display:"flex",flexDirection:"column",gap:14 }}>

          {tab === "basic" && (
            <>
              {/* Veg / Non-Veg toggle — big prominent */}
              <div style={{ display:"flex",gap:10 }}>
                <button onClick={()=>set("isVeg",true)}
                  style={{ flex:1,padding:"10px",borderRadius:12,border:`2px solid ${form.isVeg?T.green:T.border}`,background:form.isVeg?T.greenLight:"#fff",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,fontWeight:700,fontSize:"0.82rem",color:form.isVeg?T.green:T.textSub,fontFamily:"inherit" }}>
                  <div style={{ width:16,height:16,border:`2px solid ${T.green}`,borderRadius:3,display:"flex",alignItems:"center",justifyContent:"center" }}>
                    <div style={{ width:8,height:8,borderRadius:"50%",background:T.green }}/>
                  </div>
                  Veg
                </button>
                <button onClick={()=>set("isVeg",false)}
                  style={{ flex:1,padding:"10px",borderRadius:12,border:`2px solid ${!form.isVeg?T.red:T.border}`,background:!form.isVeg?T.redLight:"#fff",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,fontWeight:700,fontSize:"0.82rem",color:!form.isVeg?T.red:T.textSub,fontFamily:"inherit" }}>
                  <div style={{ width:16,height:16,border:`2px solid ${T.red}`,borderRadius:3,display:"flex",alignItems:"center",justifyContent:"center" }}>
                    <div style={{ width:8,height:8,borderRadius:"50%",background:T.red }}/>
                  </div>
                  Non-Veg
                </button>
              </div>

              {/* Name */}
              <div>
                <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>Item Name *</label>
                <input value={form.name} onChange={e=>set("name",e.target.value)} placeholder="e.g. Butter Chicken"
                  style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"10px 12px",fontSize:"0.88rem",fontFamily:"inherit",color:T.text,outline:"none",boxSizing:"border-box" }}
                  onFocus={e=>e.target.style.borderColor=T.primary} onBlur={e=>e.target.style.borderColor=T.border}/>
              </div>

              {/* Description */}
              <div>
                <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>Description</label>
                <textarea value={form.description} onChange={e=>set("description",e.target.value)}
                  placeholder="Tender chicken cooked in rich creamy tomato gravy..."
                  rows={3} style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"10px 12px",fontSize:"0.85rem",fontFamily:"inherit",color:T.text,outline:"none",resize:"vertical",boxSizing:"border-box" }}
                  onFocus={e=>e.target.style.borderColor=T.primary} onBlur={e=>e.target.style.borderColor=T.border}/>
              </div>

              {/* Price + MRP */}
              <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:10 }}>
                <div>
                  <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>Selling Price (₹) *</label>
                  <input type="number" value={form.price} onChange={e=>set("price",e.target.value)} placeholder="220"
                    style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"10px 12px",fontSize:"0.88rem",fontFamily:"inherit",color:T.text,outline:"none",boxSizing:"border-box" }}
                    onFocus={e=>e.target.style.borderColor=T.primary} onBlur={e=>e.target.style.borderColor=T.border}/>
                </div>
                <div>
                  <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>
                    MRP (₹) {discount > 0 && <span style={{ color:T.green,marginLeft:6 }}>{discount}% OFF</span>}
                  </label>
                  <input type="number" value={form.mrp} onChange={e=>set("mrp",e.target.value)} placeholder="280"
                    style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"10px 12px",fontSize:"0.88rem",fontFamily:"inherit",color:T.text,outline:"none",boxSizing:"border-box" }}
                    onFocus={e=>e.target.style.borderColor=T.primary} onBlur={e=>e.target.style.borderColor=T.border}/>
                </div>
              </div>

              {/* Category */}
              <div>
                <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>Category *</label>
                <select value={form.category} onChange={e=>set("category",e.target.value)}
                  style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"10px 12px",fontSize:"0.85rem",fontFamily:"inherit",color:T.text,background:T.white,outline:"none" }}>
                  {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>

              {/* Image URL */}
              <div>
                <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:5 }}>Image URL</label>
                <input value={form.image} onChange={e=>set("image",e.target.value)} placeholder="https://example.com/butter-chicken.jpg"
                  style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"10px 12px",fontSize:"0.85rem",fontFamily:"inherit",color:T.text,outline:"none",boxSizing:"border-box" }}
                  onFocus={e=>e.target.style.borderColor=T.primary} onBlur={e=>e.target.style.borderColor=T.border}/>
                {form.image && (
                  <div style={{ marginTop:8,borderRadius:10,overflow:"hidden",height:80,border:`1px solid ${T.border}` }}>
                    <img src={form.image} alt="preview" style={{ width:"100%",height:"100%",objectFit:"cover" }}
                      onError={e=>e.target.style.display="none"}/>
                  </div>
                )}
              </div>
            </>
          )}

          {tab === "details" && (
            <>
              {/* Spicy level */}
              <div>
                <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:8 }}>Spicy Level</label>
                <div style={{ display:"flex",gap:8,flexWrap:"wrap" }}>
                  {SPICY_LEVELS.map(s => (
                    <button key={s.val} onClick={()=>set("spicyLevel",s.val)}
                      style={{ padding:"7px 12px",borderRadius:10,border:`1.5px solid ${form.spicyLevel===s.val?T.red:T.border}`,background:form.spicyLevel===s.val?T.redLight:"#fff",cursor:"pointer",fontSize:"0.78rem",fontWeight:600,color:form.spicyLevel===s.val?T.red:T.textSub,fontFamily:"inherit",display:"flex",alignItems:"center",gap:5 }}>
                      {s.emoji} {s.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Toggles — Zomato style */}
              <div style={{ background:T.bg,borderRadius:14,overflow:"hidden" }}>
                {[
                  { k:"isBestseller",   label:"Bestseller",    desc:"Show flame badge on item",        icon:Flame, color:T.yellow },
                  { k:"isCustomisable", label:"Customisable",  desc:"Customer can customize this item", icon:Tag,   color:T.blue  },
                  { k:"isAvailable",    label:"Available",     desc:"Item is in stock & orderable",     icon:Check, color:T.green },
                ].map((tog, i) => (
                  <div key={tog.k} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"13px 14px",borderBottom:i<2?`1px solid ${T.border}`:"none" }}>
                    <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                      <div style={{ width:32,height:32,borderRadius:9,background:`${tog.color}18`,display:"flex",alignItems:"center",justifyContent:"center" }}>
                        <tog.icon size={15} color={tog.color}/>
                      </div>
                      <div>
                        <div style={{ fontWeight:600,fontSize:"0.84rem",color:T.text }}>{tog.label}</div>
                        <div style={{ fontSize:"0.7rem",color:T.textMuted }}>{tog.desc}</div>
                      </div>
                    </div>
                    <div onClick={()=>set(tog.k,!form[tog.k])} style={{ cursor:"pointer",color:form[tog.k]?T.primary:T.textMuted }}>
                      {form[tog.k]?<ToggleRight size={26}/>:<ToggleLeft size={26}/>}
                    </div>
                  </div>
                ))}
              </div>

              {/* Tags */}
              <div>
                <label style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,display:"block",marginBottom:8 }}>
                  Tags <span style={{ fontWeight:400 }}>(e.g. "must try", "chef special")</span>
                </label>
                <div style={{ display:"flex",gap:8,marginBottom:8 }}>
                  <input value={tagInput} onChange={e=>setTagInput(e.target.value)}
                    onKeyDown={e=>e.key==="Enter"&&addTag()}
                    placeholder="Type tag + Enter"
                    style={{ flex:1,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 12px",fontSize:"0.85rem",fontFamily:"inherit",color:T.text,outline:"none" }}
                    onFocus={e=>e.target.style.borderColor=T.primary} onBlur={e=>e.target.style.borderColor=T.border}/>
                  <button onClick={addTag}
                    style={{ background:T.primary,border:"none",borderRadius:10,padding:"9px 14px",color:"#fff",fontWeight:700,cursor:"pointer",fontFamily:"inherit" }}>
                    Add
                  </button>
                </div>
                {form.tags?.length > 0 && (
                  <div style={{ display:"flex",flexWrap:"wrap",gap:6 }}>
                    {form.tags.map(t => (
                      <div key={t} style={{ display:"flex",alignItems:"center",gap:5,background:T.primaryLight,border:`1px solid ${T.primaryMid}`,borderRadius:100,padding:"3px 10px",fontSize:"0.75rem",fontWeight:600,color:T.primary }}>
                        {t}
                        <button onClick={()=>removeTag(t)} style={{ background:"none",border:"none",cursor:"pointer",color:T.primary,display:"flex",padding:0 }}><X size={11}/></button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}

          {/* Save button */}
          <button onClick={handleSave} disabled={saving}
            style={{ background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,border:"none",borderRadius:12,padding:"12px",color:"#fff",fontWeight:800,fontSize:"0.9rem",cursor:saving?"not-allowed":"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginTop:4,boxShadow:"0 4px 14px rgba(249,115,22,0.3)" }}>
            {saving?<><Loader2 size={16} style={{ animation:"spin .8s linear infinite" }}/> Saving...</>:<><Check size={16}/> {form._id?"Update Item":"Add to Menu"}</>}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Menu Item Card ───────────────────────────────
function ItemCard({ item, onEdit, onDelete, onToggle, i }) {
  const discount = item.mrp && item.mrp > item.price
    ? Math.round(((item.mrp - item.price) / item.mrp) * 100)
    : 0;

  return (
    <div style={{ background:T.white,borderRadius:16,border:`1.5px solid ${item.isAvailable?T.border:"#fecaca"}`,padding:"16px",animation:`fadeUp .3s ${i*0.04}s ease both`,opacity:item.isAvailable?1:0.7 }}>

      <div style={{ display:"flex",gap:12,alignItems:"flex-start" }}>
        {/* Left */}
        <div style={{ flex:1,minWidth:0 }}>
          {/* Veg dot + badges */}
          <div style={{ display:"flex",alignItems:"center",gap:6,marginBottom:6,flexWrap:"wrap" }}>
            <div style={{ width:16,height:16,border:`2px solid ${item.isVeg?T.green:T.red}`,borderRadius:3,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0 }}>
              <div style={{ width:8,height:8,borderRadius:"50%",background:item.isVeg?T.green:T.red }}/>
            </div>
            {item.isBestseller && (
              <div style={{ display:"flex",alignItems:"center",gap:3,background:T.yellowLight,border:`1px solid #fde68a`,borderRadius:6,padding:"2px 7px",fontSize:"0.6rem",fontWeight:700,color:"#92400e" }}>
                <Flame size={9} fill="#92400e" color="#92400e"/> BESTSELLER
              </div>
            )}
            {item.isCustomisable && (
              <div style={{ background:T.blueLight,borderRadius:6,padding:"2px 7px",fontSize:"0.6rem",fontWeight:700,color:T.blue }}>CUSTOMISABLE</div>
            )}
            {item.spicyLevel > 0 && (
              <div style={{ fontSize:"0.65rem" }}>{SPICY_LEVELS[item.spicyLevel]?.emoji}</div>
            )}
          </div>

          <div style={{ fontWeight:700,fontSize:"0.92rem",color:T.text,marginBottom:4 }}>{item.name}</div>

          {/* Price row */}
          <div style={{ display:"flex",alignItems:"center",gap:8,marginBottom:6 }}>
            <span style={{ fontWeight:800,fontSize:"0.95rem",color:T.text }}>₹{item.price}</span>
            {item.mrp > item.price && (
              <>
                <span style={{ fontSize:"0.78rem",color:T.textMuted,textDecoration:"line-through" }}>₹{item.mrp}</span>
                <span style={{ background:T.greenLight,color:T.green,fontSize:"0.65rem",fontWeight:700,padding:"2px 7px",borderRadius:100 }}>{discount}% off</span>
              </>
            )}
          </div>

          {item.description && (
            <div style={{ fontSize:"0.75rem",color:T.textMuted,lineHeight:1.5,marginBottom:6,display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden" }}>
              {item.description}
            </div>
          )}

          {/* Category chip */}
          <div style={{ display:"inline-block",background:T.primaryLight,color:T.primary,fontSize:"0.65rem",fontWeight:700,padding:"2px 9px",borderRadius:100,border:`1px solid ${T.primaryMid}` }}>
            {item.category}
          </div>
        </div>

        {/* Right: image */}
        <div style={{ flexShrink:0,display:"flex",flexDirection:"column",alignItems:"center",gap:8 }}>
          <div style={{ width:80,height:80,borderRadius:12,overflow:"hidden",background:`linear-gradient(135deg,${T.primaryLight},${T.primaryMid})`,display:"flex",alignItems:"center",justifyContent:"center",border:`1px solid ${T.border}` }}>
            {item.image
              ? <img src={item.image} alt={item.name} style={{ width:"100%",height:"100%",objectFit:"cover" }}/>
              : <UtensilsCrossed size={28} color={T.primary} strokeWidth={1.5}/>
            }
          </div>
        </div>
      </div>

      {/* Actions */}
      <div style={{ display:"flex",gap:8,marginTop:12,paddingTop:12,borderTop:`1px solid ${T.border}` }}>
        <button onClick={()=>onToggle(item._id)}
          style={{ flex:1,background:item.isAvailable?T.greenLight:T.redLight,border:"none",borderRadius:9,padding:"7px",fontWeight:700,fontSize:"0.75rem",cursor:"pointer",color:item.isAvailable?T.green:T.red,fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:4 }}>
          {item.isAvailable?<ToggleRight size={13}/>:<ToggleLeft size={13}/>}
          {item.isAvailable?"Available":"Unavailable"}
        </button>
        <button onClick={()=>onEdit(item)}
          style={{ flex:1,background:T.primaryLight,border:"none",borderRadius:9,padding:"7px",fontWeight:700,fontSize:"0.75rem",cursor:"pointer",color:T.primary,fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:4 }}>
          <Edit2 size={12}/> Edit
        </button>
        <button onClick={()=>onDelete(item._id)}
          style={{ background:T.redLight,border:"none",borderRadius:9,padding:"7px 10px",cursor:"pointer",color:T.red,display:"flex",alignItems:"center",justifyContent:"center" }}>
          <Trash2 size={13}/>
        </button>
      </div>
    </div>
  );
}

// ── MAIN PAGE ────────────────────────────────────
export default function MenuItems() {
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRest, setSelectedRest] = useState(null);
  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingRest, setLoadingRest] = useState(true);
  const [error,   setError]   = useState(null);
  const [modal,   setModal]   = useState(null);
  const [search,  setSearch]  = useState("");
  const [filterCat, setFilterCat] = useState("All");
  const [filterVeg, setFilterVeg] = useState("all"); // all | veg | nonveg
  const [toast,   setToast]   = useState("");
  const [bulkModal, setBulkModal] = useState(false);

  const showToast = m => { setToast(m); setTimeout(()=>setToast(""),2500); };

  // ── Load restaurants ──────────────────────────
  useEffect(() => {
    (async () => {
      setLoadingRest(true);
      const res = await req("GET", "/restaurants");
      if (res.success) setRestaurants(res.data || []);
      setLoadingRest(false);
    })();
  }, []);

  // ── Load menu items ───────────────────────────
  const loadItems = async (restId) => {
    if (!restId) return;
    setLoading(true);
    setError(null);
    const res = await req("GET", `/menu/restaurant/${restId}`);
    if (res.success) setItems(res.data || []);
    else setError(res.message);
    setLoading(false);
  };

  const handleRestSelect = (rest) => {
    setSelectedRest(rest);
    setItems([]);
    setFilterCat("All");
    loadItems(rest._id);
  };

  // ── Toggle availability ───────────────────────
  const handleToggle = async (id) => {
    const res = await req("PATCH", `/menu/${id}/toggle`);
    if (res.success) {
      setItems(prev => prev.map(x => x._id===id ? res.data : x));
      showToast(`Item ${res.data.isAvailable?"available":"unavailable"}!`);
    }
  };

  // ── Delete item ───────────────────────────────
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this item?")) return;
    const res = await req("DELETE", `/menu/${id}`);
    if (res.success) {
      setItems(prev => prev.filter(x => x._id!==id));
      showToast("Item deleted!");
    }
  };

  // ── Save (add/edit) ───────────────────────────
  const handleSave = (data, isEdit) => {
    if (isEdit) setItems(prev => prev.map(x => x._id===data._id ? data : x));
    else        setItems(prev => [data, ...prev]);
    setModal(null);
    showToast(isEdit ? "Item updated!" : "Item added to menu!");
  };

  // ── Filter items ──────────────────────────────
  const categories = ["All", ...new Set(items.map(i => i.category))];

  const filtered = items.filter(item => {
    const matchSearch = !search || item.name.toLowerCase().includes(search.toLowerCase());
    const matchCat    = filterCat === "All" || item.category === filterCat;
    const matchVeg    = filterVeg === "all" || (filterVeg==="veg" ? item.isVeg : !item.isVeg);
    return matchSearch && matchCat && matchVeg;
  });

  // Group by category
  const grouped = categories.filter(c => c !== "All").reduce((acc, cat) => {
    const catItems = filtered.filter(i => i.category === cat);
    if (catItems.length) acc[cat] = catItems;
    return acc;
  }, {});

  const availCount   = items.filter(i => i.isAvailable).length;
  const unavailCount = items.length - availCount;

  return (
    <div style={{ fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <style>{`
        @keyframes fadeUp { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
        @keyframes spin   { to { transform: rotate(360deg); } }
      `}</style>

      {/* Toast */}
      {toast && (
        <div style={{ position:"fixed",top:80,left:"50%",transform:"translateX(-50%)",background:T.text,color:"#fff",padding:"10px 22px",borderRadius:100,fontSize:"0.82rem",fontWeight:600,zIndex:600,display:"flex",alignItems:"center",gap:8,boxShadow:"0 4px 20px rgba(0,0,0,0.2)" }}>
          <Check size={14} color={T.green}/> {toast}
        </div>
      )}

      {/* ── STEP 1: Restaurant Selector ── */}
      <div style={{ background:T.white,borderRadius:16,border:`1px solid ${T.border}`,padding:"18px 20px",marginBottom:16 }}>
        <div style={{ fontSize:"0.72rem",fontWeight:700,color:T.textMuted,letterSpacing:"1px",textTransform:"uppercase",marginBottom:12 }}>
          Step 1 — Select Restaurant
        </div>

        {loadingRest ? (
          <div style={{ color:T.textMuted,fontSize:"0.82rem",display:"flex",alignItems:"center",gap:8 }}>
            <Loader2 size={14} style={{ animation:"spin 1s linear infinite" }}/> Loading restaurants...
          </div>
        ) : restaurants.length === 0 ? (
          <div style={{ color:T.textMuted,fontSize:"0.82rem" }}>Koi restaurants nahi — pehle restaurant add karo!</div>
        ) : (
          <div style={{ display:"flex",gap:10,flexWrap:"wrap" }}>
            {restaurants.map(r => (
              <button key={r._id} onClick={() => handleRestSelect(r)}
                style={{ display:"flex",alignItems:"center",gap:8,padding:"10px 16px",borderRadius:12,border:`2px solid ${selectedRest?._id===r._id?T.primary:T.border}`,background:selectedRest?._id===r._id?T.primaryLight:"#fff",cursor:"pointer",fontFamily:"inherit",transition:"all .2s" }}>
                <div style={{ width:32,height:32,borderRadius:9,background:`linear-gradient(135deg,${T.primaryDark},${T.primary})`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0 }}>
                  <UtensilsCrossed size={15} color="#fff"/>
                </div>
                <div style={{ textAlign:"left" }}>
                  <div style={{ fontWeight:700,fontSize:"0.82rem",color:selectedRest?._id===r._id?T.primary:T.text }}>{r.name}</div>
                  <div style={{ fontSize:"0.68rem",color:T.textMuted }}>{r.area || "Akola"}</div>
                </div>
                {selectedRest?._id===r._id && <Check size={14} color={T.primary}/>}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* ── STEP 2: Menu Items ── */}
      {selectedRest && (
        <>
          {/* Header */}
          <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14,flexWrap:"wrap",gap:12 }}>
            <div>
              <div style={{ fontFamily:"'Fraunces',Georgia,serif",fontWeight:900,fontSize:"1.05rem",color:T.text }}>
                {selectedRest.name} — Menu
              </div>
              <div style={{ fontSize:"0.72rem",color:T.textMuted,marginTop:3,display:"flex",gap:12 }}>
                <span>{items.length} items total</span>
                <span style={{ color:T.green }}>✓ {availCount} available</span>
                {unavailCount > 0 && <span style={{ color:T.red }}>✗ {unavailCount} unavailable</span>}
              </div>
            </div>
            <div style={{ display:"flex",gap:8 }}>
              <button onClick={()=>loadItems(selectedRest._id)}
                style={{ background:T.white,border:`1px solid ${T.border}`,borderRadius:10,padding:"8px 14px",cursor:"pointer",display:"flex",alignItems:"center",gap:6,fontSize:"0.78rem",fontWeight:600,color:T.textSub,fontFamily:"inherit" }}>
                <RefreshCw size={13} style={loading?{animation:"spin 1s linear infinite"}:{}}/> Refresh
              </button>
              <button onClick={()=>setBulkModal(true)}
                style={{ background:"#fff",border:`1.5px solid ${T.primary}`,borderRadius:10,padding:"9px 16px",fontWeight:700,fontSize:"0.82rem",color:T.primary,cursor:"pointer",display:"flex",alignItems:"center",gap:6,fontFamily:"inherit" }}>
                <Upload size={15}/> Bulk Upload
              </button>
              <button onClick={()=>setModal("add")}
                style={{ background:T.primary,border:"none",borderRadius:10,padding:"9px 18px",fontWeight:700,fontSize:"0.85rem",color:"#fff",cursor:"pointer",display:"flex",alignItems:"center",gap:6,fontFamily:"inherit",boxShadow:"0 4px 12px rgba(249,115,22,0.3)" }}>
                <Plus size={16}/> Add Item
              </button>
            </div>
          </div>

          {/* Filters */}
          <div style={{ display:"flex",gap:10,marginBottom:16,flexWrap:"wrap",alignItems:"center" }}>
            {/* Search */}
            <div style={{ display:"flex",alignItems:"center",gap:8,background:T.white,border:`1.5px solid ${T.border}`,borderRadius:10,padding:"8px 12px",flex:1,maxWidth:280 }}>
              <Search size={14} color={T.textMuted}/>
              <input placeholder="Search items..." value={search} onChange={e=>setSearch(e.target.value)}
                style={{ border:"none",background:"transparent",color:T.text,fontSize:"0.83rem",outline:"none",fontFamily:"inherit",width:"100%" }}/>
              {search && <button onClick={()=>setSearch("")} style={{ background:"none",border:"none",cursor:"pointer",color:T.textMuted,display:"flex",padding:0 }}><X size={13}/></button>}
            </div>

            {/* Veg filter */}
            {["all","veg","nonveg"].map(v => (
              <button key={v} onClick={()=>setFilterVeg(v)}
                style={{ padding:"7px 14px",borderRadius:10,border:`1.5px solid ${filterVeg===v?(v==="veg"?T.green:v==="nonveg"?T.red:T.primary):T.border}`,background:filterVeg===v?(v==="veg"?T.greenLight:v==="nonveg"?T.redLight:T.primaryLight):"#fff",cursor:"pointer",fontSize:"0.78rem",fontWeight:600,color:filterVeg===v?(v==="veg"?T.green:v==="nonveg"?T.red:T.primary):T.textSub,fontFamily:"inherit" }}>
                {v==="all"?"All":v==="veg"?"🟢 Veg":"🔴 Non-Veg"}
              </button>
            ))}

            {/* Category tabs */}
            <div style={{ display:"flex",gap:6,overflowX:"auto",scrollbarWidth:"none",flex:1 }}>
              {categories.map(c => (
                <button key={c} onClick={()=>setFilterCat(c)}
                  style={{ flexShrink:0,padding:"7px 14px",borderRadius:10,border:`1.5px solid ${filterCat===c?T.primary:T.border}`,background:filterCat===c?T.primaryLight:"#fff",cursor:"pointer",fontSize:"0.78rem",fontWeight:filterCat===c?700:500,color:filterCat===c?T.primary:T.textSub,fontFamily:"inherit",whiteSpace:"nowrap" }}>
                  {c}
                </button>
              ))}
            </div>
          </div>

          {/* Error */}
          {error && (
            <div style={{ background:T.redLight,border:`1px solid #fecaca`,borderRadius:12,padding:"12px 16px",marginBottom:14,display:"flex",alignItems:"center",gap:10 }}>
              <AlertCircle size={16} color={T.red}/>
              <span style={{ fontSize:"0.82rem",color:T.red,fontWeight:600 }}>{error}</span>
              <button onClick={()=>loadItems(selectedRest._id)} style={{ marginLeft:"auto",background:T.red,border:"none",borderRadius:8,padding:"5px 12px",color:"#fff",fontWeight:700,cursor:"pointer",fontFamily:"inherit",fontSize:"0.75rem" }}>Retry</button>
            </div>
          )}

          {/* Loading */}
          {loading && (
            <div style={{ textAlign:"center",padding:48,color:T.textMuted }}>
              <Loader2 size={28} style={{ animation:"spin 1s linear infinite",color:T.primary,marginBottom:10 }}/>
              <div>Loading menu items...</div>
            </div>
          )}

          {/* Empty */}
          {!loading && !error && items.length === 0 && (
            <div style={{ textAlign:"center",padding:60,background:T.white,borderRadius:16,border:`1px solid ${T.border}` }}>
              <UtensilsCrossed size={48} color={T.border} strokeWidth={1.2} style={{ marginBottom:12 }}/>
              <div style={{ fontWeight:700,color:T.textSub,marginBottom:8 }}>Menu empty hai!</div>
              <div style={{ fontSize:"0.82rem",color:T.textMuted,marginBottom:20 }}>Is restaurant ke liye pehla item add karo</div>
              <button onClick={()=>setModal("add")}
                style={{ background:T.primary,border:"none",borderRadius:12,padding:"11px 24px",color:"#fff",fontWeight:700,cursor:"pointer",fontFamily:"inherit",fontSize:"0.88rem" }}>
                + Add First Item
              </button>
            </div>
          )}

          {/* Items — grouped by category */}
          {!loading && !error && filtered.length > 0 && (
            filterCat === "All" ? (
              Object.entries(grouped).map(([cat, catItems]) => (
                <div key={cat} style={{ marginBottom:24 }}>
                  <div style={{ display:"flex",alignItems:"center",gap:10,marginBottom:12 }}>
                    <div style={{ fontFamily:"'Fraunces',Georgia,serif",fontWeight:800,fontSize:"1rem",color:T.text }}>{cat}</div>
                    <div style={{ background:T.primaryLight,color:T.primary,fontSize:"0.65rem",fontWeight:700,padding:"2px 8px",borderRadius:100 }}>{catItems.length}</div>
                    <div style={{ flex:1,height:1,background:T.border }}/>
                  </div>
                  <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:12 }}>
                    {catItems.map((item,i) => (
                      <ItemCard key={item._id} item={item} i={i}
                        onEdit={setModal} onDelete={handleDelete} onToggle={handleToggle}/>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:12 }}>
                {filtered.map((item,i) => (
                  <ItemCard key={item._id} item={item} i={i}
                    onEdit={setModal} onDelete={handleDelete} onToggle={handleToggle}/>
                ))}
              </div>
            )
          )}
        </>
      )}

      {/* ── Modal ── */}
      {modal && (
        <ItemModal
          item={modal==="add" ? null : modal}
          restaurantId={selectedRest?._id}
          restaurantName={selectedRest?.name}
          onClose={()=>setModal(null)}
          onSave={handleSave}
        />
      )}

      {/* ── Bulk Upload Modal ── */}
      {bulkModal && selectedRest && (
        <BulkUploadModal
          restaurantId={selectedRest._id}
          restaurantName={selectedRest.name}
          onClose={() => setBulkModal(false)}
          onSuccess={() => { setBulkModal(false); loadItems(selectedRest._id); showToast("Items uploaded successfully!"); }}
          T={T}
        />
      )}
    </div>
  );
}